<template>
    <div class="col-md-12 mx-auto">
        <div v-if="response.isSuccess">
            <div class="buildingListContainer" v-bind:class="{'active':openList === true}">
                <div class="form-group hasSearch">
                    <input type="text" class="form-control hasSearch-formControl" v-model="searchText" placeholder="Search Buildings">
                    <i class="fa fa-search hasSearch-icon"></i>
                </div>
                <div class="buildingList">
                    <template v-for="(building, index) in buildingFilted">
                        <div class="buildingList-item" v-bind:class="{'active':activeBuildingId === building.id, 'loading': loadingBuildingId === building.id}"
                             v-bind:data-id="building.id"
                             ref="buildings">
                            <button class="buildingList-item-text" v-on:click="loadBuildingCard(building)" >
                                <span class="d-block text-truncate buildingList-item-buildingName" v-bind:title="building.name">{{building.name}}</span>
                                <span class="d-block text-truncate buildingList-item-address" v-bind:title="building.fullAddress">{{building.fullAddress}}</span>
                                <span v-if="building.strata_no" class="d-block text-truncate buildingList-item-spDp" v-bind:title="'SP: ' + building.strata_no">SP: {{building.strata_no}}</span>
                                <div class="buildingList-item-loading">
                                    <div class="spinner-border spinner-border-sm buildingList-item-loading-icon" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </template>
                </div>
            </div>

            <BuildingCard :key="componentKey"
                    v-if="activeBuildingId !== undefined"
                    v-bind:buildingId="activeBuildingId"
                    v-bind:scrollIntoView.sync="scrollIntoView"
                    v-bind:buildingLatitude="activeBuilding.latitude"
                    v-bind:buildingLongitude="activeBuilding.longitude"
                    v-bind:buildingStrataNo="activeBuilding.strata_no"
                    v-bind:buildingSuburb="activeBuilding.suburb"
                    v-bind:building_post_code="activeBuilding.post_code"
                    v-bind:buildingState="activeBuilding.state"
                    v-bind:buildingStreetAddress="activeBuilding.address"
                    v-bind:buildingName="activeBuilding.name"
                    v-bind:buildingRole="activeBuilding.building_role"
                    v-bind:buildingAddress="activeBuilding.fullAddress"
                    v-bind:buildingStatusColor="activeBuilding.statusStyle[0]"
                    v-bind:timeZone="activeBuilding.time_zone"
            ></BuildingCard>

        </div>
        <transition name="fade">
            <div class="alert alert-danger" v-if="response.isError">
                <p class="text-center">There is no building attached to your email. Please contact your building
                    manager</p>
            </div>
        </transition>
        <router-view class="container-fluid"></router-view>
    </div>
</template>
<script>
import Tools from '@/app-model/tools.js';
import Building from '@/app-model/building.js';
import ConnectionService from '@/app-model/model';
import BuildingCard from '@/components/building-management/BuildingCard.vue';

const connectionService = new ConnectionService()
  export default {
    data() {
      return {
        componentKey: undefined,
        searchText: '',
        openList: true,
        loadingBuildingId: undefined,
        activeBuildingId: undefined,
        activeBuilding: {
          strata_no: undefined,
          name: undefined,
          building_role: undefined,
          address: undefined,
          time_zone:undefined,
          latitude: undefined,
          longitude: undefined,
          statusStyle: [],
        },
        scrollIntoView: undefined,
        schedule_test: [],
        response: {
          isError: false,
          isSuccess: false
        },
      }
    },
    computed: {
      tools: function () {
        return new Tools
      },
      buildings: function () {
        return this.$store.getters.buildings;
      },
      buildingModel: function () {
        return new Building;
      },
      buildingFilted: function () {
        return this.buildings.filter((el) => {
          let searchText = this.searchText
              .replace(/\W/g, ' ')
              .replace(/\s+/g, ' ')
              .toLowerCase()
              .split(' ')
              .filter(txt => txt !== ''),
            context = el.search;
          if(this.searchText.length) {
            for(let i = 0; i < searchText.length; i++) {
              if(context.indexOf(searchText[i]) === -1){
                return false;
              }
            }
          }
          return true;
        });
      }
    },
    mounted() {
    },
    created() {
      document.documentElement.classList.add('building-management');

      let {b: buildingId, scrollIntoView} = this.tools.getDataFromUrlHash({scrollIntoView}, ['b', 'scrollIntoView']);

      this.scrollIntoView = scrollIntoView;

      let extra = {
        key: undefined,
        parking: undefined,
        toilet: undefined,
        note: undefined
      };

      this.buildingModel.loadBuildings({store: this.$store, extra}).then(response => {
        switch (response.status) {
          case 200 :
            document.documentElement.classList.add('secondNav');
            if (this.buildings.length) {
              if(buildingId) {
                //not require reset url hash
                this.loadBuildingCard(this.buildings.find(el => el.id === buildingId), false, true);
              }
              else {
                //require reset url hash
                this.loadBuildingCard(this.buildings.find(el => el.id === this.buildings[0].id), false, false);
              }
            }

            this.response.isSuccess = true;
            break;
        }

        return response;
      }).then(response => {
        if(buildingId) {
          let index = this.$refs.buildings.findIndex(el => el.getAttribute('data-id') === buildingId.toString());
          this.$refs.buildings[index].scrollIntoView();
        }
      });
    },
    beforeDestroy() {
      document.documentElement.classList.remove('secondNav');
    },
    components: {
      BuildingCard
    },
    methods: {
      setScrollIntoView(ref) {
        this.scrollIntoView = ref;
        this.tools.setUrlHashByData(this, ['scrollIntoView'], {buildingId: this.activeBuildingId}, `building-${this.activeBuildingId}`, false);
      },
      async loadBuildingCard(building, removeCssClass = true, init = false) {
        let buildingId = building.id;

        if(!init) {
          this.tools.setUrlHashByData({b: buildingId}, ['b'], {buildingId}, `building-${buildingId}`, true);
        }

        this.loadingBuildingId = buildingId;

        await this.loadPermission(buildingId);

        this.loadingBuildingId = undefined;

        this.activeBuildingId = buildingId;
        this.activeBuilding = building;
        this.scrollIntoView = init ? this.scrollIntoView : undefined;

        if(removeCssClass) {
          document.documentElement.classList.remove('building-management');
        }

        this.componentKey = buildingId;
      },
      async loadPermission(buildingId) {
        if (this
          .$store
          .getters
          .buildingPermissions['/api/user-buildings/' + buildingId + '/permissions'] === undefined) {

          await this
            .$store
            .dispatch('apiResult', {
              method: 'GET',
              path: `api/user-buildings/${buildingId}/permissions`,
              path_template: '/api/user-buildings/{building_id}/permissions',
              building_id: buildingId
            });
        }
        return true;
      },
      hasRouter(routeName, buildingId) {
        let routers = nameAndRouteData((el) => el.routeName === routeName, buildingId, this.$store);
        return routers.length > 0;
      }
    },
  }
</script>
<style lang="scss" scoped>
    @import "@/../sass/_home-building.scss";
</style>